/* eslint-disable */
import React, { useContext, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import RemoveIcon from 'assets/icons/remove-icon'
import ConfirmIcon from 'assets/icons/confirm-icon'
import RejectIcon from 'assets/icons/reject-icon'
import AssessIcon from 'assets/icons/assess-icon'
import ReassessIcon from 'assets/icons/reassess-icon'
import PulsingNotification from 'features/PulsingNotification'
import { SiteContext } from 'providers/site'
import { defaultSiteProposalValidationResults } from 'constants/defaultSiteProposalValidationResults'
import { SITE_STATUS_DRAFT_ID, SITE_STATUS_NOMINATED_ID } from 'constants/siteStatuses'
import { ProfileContext } from 'providers/profile'
import { SECRETARIAT_ROLE_ID, BIRDLIFE_SECRETARIAT_ROLE_ID } from 'constants/roles'
import CancelIcon from 'assets/icons/cancel-icon16px'
import ActionsMenu from 'features/ActionMenu'
import { confirmEcoSystem, cancelEcosystemReassessmentRequest } from 'api/ecoSystem'
import Tooltip from 'components/Tooltip'
import Button from 'components/Button'
import { showErrorToast } from 'utils/toast'
import Modal from 'components/Modal'
import FlowRequestModal from 'components/FlowRequestModal'
import CalendarIcon from 'assets/icons/calendar-icon'
import { reassessmentTriggerReasons } from 'constants/reassessmentTriggerReasons'
import DropdownIndicatorIconOpen from 'assets/icons/dropdown-indicator-opened24px'
import DropdownIndicatorIconClosed from 'assets/icons/dropdown-indicator-closed24px'
import { INDIVIDUAL_ROLE_ID } from 'constants/roles'

import {
  EcosystemActionMenuWrapper,
  EcosystemCalendarDateText, EcosystemCalendarDivider, EcosystemCalendarIconWrapper,
  EcosystemConfirmDeclineIcon,
  EcosystemHeaderIcon,
  EcosystemHeaderIconWrapper,
  EcosystemHeaderNavbarHalfSide,
  EcosystemHeaderNavbarIconWrapper,
  EcosystemHeaderNavbarWrapper,
  EcosystemHeaderTitle, EcosystemLastReassessmentCalendarWrapper, EcosystemToggleWrapper,
  EcoSystemValidationIcon, EcosystemValidationIconWrapper,
  EcosystemsCancelIconWrapper
} from './style'
import { formatDate } from 'utils/dateFormat'

const formattedRejectIconTooltipHint = (item) => {
  return item.triggerReasonId.map((element) => {
    return reassessmentTriggerReasons.find((elementId) => {
      return elementId.id === element
    }).name
  })
}


const tooltipXOffset = 0
const tooltipYOffset = -16

const EcoSystemAccordionHeader = ({ isOpen, item, openRemoveEcoSystemModal, getEcosystems, toggleAccordion, lastItem, newTriggers = false, oldTriggers = false }) => {
  const { site, siteProposalFieldValidation, isEditable } = useContext(SiteContext)
  const { profile } = useContext(ProfileContext)
  const isIndividualUser = profile.Role.id === INDIVIDUAL_ROLE_ID
  const dateToShow = item.reassessmentFlag ? formatDate(item.updatedAt) : formatDate(item.lastReassessmentDate)
  const [isCancelOpen, setIsCancelOpen] = useState(false)
  const [ecosystemToCancel, setEcosystemToCancel] = useState(null)

  const handleEcosystemAction = (isApproved) => {
    confirmEcoSystem(item.id, isApproved).then((data) => {
      getEcosystems()
    })
  }

  const actionMenuItems = item.isApprovedBySecretariat ? [{
    icon: <RejectIcon />,
    title: 'rejectEcosystem',
    onClick: () => {
      handleEcosystemAction({ isApproved: false })
    },
    isDestructive: true
  }] : [{
    icon: <ConfirmIcon />,
    title: 'confirmEcosystem',
    onClick: () => {
      handleEcosystemAction({ isApproved: true })
    }
  }]

  const validationEcosystem = siteProposalFieldValidation.ecoSystem[item.id]
    ? siteProposalFieldValidation.ecoSystem[item.id]
    : defaultSiteProposalValidationResults.ecoSystem

  const fieldsToCompleteNumber = Object.values(validationEcosystem).filter((element) => {
    return element === false
  })

  const qulifyes = item.reassessmentFlag ? item.triggerReasonId?.some((element) => {
    // eslint-disable-next-line no-magic-numbers
    return element === 1
  }) : true

  const cancelEcosystemsChanges = (ecosystem) => {
    if (!isIndividualUser) {
      showErrorToast('This action is not allowed.')
      return
    }
    cancelEcosystemReassessmentRequest({ siteId: site.historyId, ecosystemId: ecosystem.id, isCancelled: true }).then((data) => {
      if (data.error) {
        return showErrorToast(data.error)
      }
      setIsCancelOpen(false)
      setEcosystemToCancel(null)
      getEcosystems()
    })
  }

  const disabled = site.SiteStatusId !== SITE_STATUS_DRAFT_ID || (!isEditable && site.SiteStatusId === SITE_STATUS_DRAFT_ID) || !qulifyes

  return (
    <>
      <EcosystemHeaderNavbarWrapper
        isOpen={isOpen}
        bottomBorder={isOpen || lastItem}
        data-test='ecosystem'
        onClick={() => { }}>
        <EcosystemHeaderNavbarHalfSide onClick={toggleAccordion}>
          <EcosystemHeaderIconWrapper>
            <EcosystemHeaderIcon isRejected={!qulifyes} />
          </EcosystemHeaderIconWrapper>
          <EcosystemHeaderTitle
            isRejected={!qulifyes}
            data-test='ecosystem-name'
            isReassess={item.lastReassessmentDate}
          >
            {item.name}
          </EcosystemHeaderTitle>
        </EcosystemHeaderNavbarHalfSide>
        <EcosystemHeaderNavbarHalfSide>
          {site.reassessmentFlag ? (
            <>
              {dateToShow !== '' && (
                <Tooltip
                  style={{ zIndex: 1000 }}
                  placement='top'
                  trigger={['hover']}
                  align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                  overlay={{ label: 'lastTimeReassessed' }}
                >

                  <EcosystemLastReassessmentCalendarWrapper>
                    <EcosystemCalendarIconWrapper>
                      <CalendarIcon />
                    </EcosystemCalendarIconWrapper>
                    <EcosystemCalendarDateText>
                      {dateToShow}
                    </EcosystemCalendarDateText>
                    <EcosystemCalendarDivider />
                  </EcosystemLastReassessmentCalendarWrapper>

                </Tooltip>
              )}
              <EcosystemConfirmDeclineIcon type={qulifyes ? 'confirmed' : 'rejected'}>
                {qulifyes ? (
                  <Tooltip
                    style={{ zIndex: 1000 }}
                    placement='top'
                    trigger={['hover']}
                    align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                    overlay={{ label: 'qualifies' }}
                  >
                    <div>
                      <ConfirmIcon />
                    </div>
                  </Tooltip>
                ) : (
                  <Tooltip
                    style={{ zIndex: 1000 }}
                    placement='top'
                    trigger={['hover']}
                    align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                    overlay={{ label: 'nonQualifying', infoTooltip: formattedRejectIconTooltipHint(item).join(', ') }}
                  >
                    <div>
                      <RejectIcon />
                    </div>
                  </Tooltip>
                )}
              </EcosystemConfirmDeclineIcon>
              {site.SiteStatusId === SITE_STATUS_DRAFT_ID ? (
                <>
                  <Button
                    isDisabled={isOpen}
                    type={isOpen ? 'defaultDisabled' : ' '}
                    height='32px'
                    marginTop='0'
                    onClick={toggleAccordion}>
                    <ReassessIcon />
                    <FormattedMessage id={oldTriggers ? 'reassess' : newTriggers ? 'assess' : 'reassess'} />
                  </Button>

                  {oldTriggers && <EcosystemsCancelIconWrapper onClick={(e) => {
                    e.stopPropagation()
                    setEcosystemToCancel(item)
                    setIsCancelOpen(true)
                  }}>
                    <CancelIcon />
                  </EcosystemsCancelIconWrapper>
                  }
                </>
              ) : (
                <>
                  <EcosystemToggleWrapper isActive={isOpen} onClick={toggleAccordion}>
                    <FormattedMessage id='expand' />
                    {isOpen ? <DropdownIndicatorIconOpen /> : <DropdownIndicatorIconClosed />}
                  </EcosystemToggleWrapper>
                </>
              )}
              {(!item.lastReassessmentDate && site.SiteStatusId === SITE_STATUS_DRAFT_ID && !disabled) && (
                <>
                  <EcosystemHeaderNavbarIconWrapper
                    delete={true}
                    data-test='remove-button'
                    onClick={(e) => {
                      e.stopPropagation()
                      openRemoveEcoSystemModal(item)
                    }}
                  >
                    <RemoveIcon />
                  </EcosystemHeaderNavbarIconWrapper>
                </>
              )}
              {fieldsToCompleteNumber.length > 0 && (
                <EcosystemValidationIconWrapper>
                  <EcoSystemValidationIcon>
                    <PulsingNotification number={fieldsToCompleteNumber.length} />
                  </EcoSystemValidationIcon>
                </EcosystemValidationIconWrapper>
              )}
            </>
          ) : (
            <>
              <>
                {site.SiteStatusId === SITE_STATUS_DRAFT_ID ? (
                  <Button
                    height='32px'
                    onClick={toggleAccordion}
                    marginTop='0'
                    isDisabled={isOpen}
                    type={isOpen ? 'defaultDisabled' : ''}
                  >
                    <AssessIcon />
                    <FormattedMessage id={oldTriggers ? 'reassess' : newTriggers ? 'assess' : 'reassess'} />
                  </Button>
                ) : (
                  <>
                    {dateToShow !== '' && (
                      <Tooltip
                        style={{ zIndex: 1000 }}
                        placement='top'
                        trigger={['hover']}
                        align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                        overlay={{ label: 'lastTimeReassessed' }}
                      >

                        <EcosystemLastReassessmentCalendarWrapper>
                          <EcosystemCalendarIconWrapper>
                            <CalendarIcon />
                          </EcosystemCalendarIconWrapper>
                          <EcosystemCalendarDateText>
                            {dateToShow}
                          </EcosystemCalendarDateText>
                          <EcosystemCalendarDivider />
                        </EcosystemLastReassessmentCalendarWrapper>

                      </Tooltip>
                    )}
                    <EcosystemToggleWrapper isActive={isOpen} onClick={toggleAccordion}>
                      <FormattedMessage id='expand' />
                      {isOpen ? <DropdownIndicatorIconOpen /> : <DropdownIndicatorIconClosed />}
                    </EcosystemToggleWrapper>
                  </>
                )}
              </>
              {site.SiteStatusId === SITE_STATUS_DRAFT_ID && !disabled && (
                <>
                  <EcosystemHeaderNavbarIconWrapper
                    data-test='remove-button'
                    onClick={(e) => {
                      e.stopPropagation()
                      openRemoveEcoSystemModal(item)
                    }}
                  >
                    <RemoveIcon />
                  </EcosystemHeaderNavbarIconWrapper>
                </>
              )}
              {(site.SiteStatusId === SITE_STATUS_NOMINATED_ID && (profile.RoleId === SECRETARIAT_ROLE_ID || profile.RoleId === BIRDLIFE_SECRETARIAT_ROLE_ID)) &&
                <EcosystemActionMenuWrapper>
                  <ActionsMenu table={false} dropdownItems={actionMenuItems} margin='0' />
                </EcosystemActionMenuWrapper>
              }
              {fieldsToCompleteNumber.length > 0 && (
                <EcosystemValidationIconWrapper>
                  <EcoSystemValidationIcon>
                    <PulsingNotification number={fieldsToCompleteNumber.length} />
                  </EcoSystemValidationIcon>
                </EcosystemValidationIconWrapper>
              )}
            </>
          )}
        </EcosystemHeaderNavbarHalfSide>
      </EcosystemHeaderNavbarWrapper>
      <Modal
        width='416px'
        isOpen={isCancelOpen}
        toggleModal={setIsCancelOpen}
        modalTitleId='cancelEcosystemReassessment'
      >
        <FlowRequestModal
          cancelHandler={() => {
            setIsCancelOpen(false)
            setEcosystemToCancel(null)
          }}
          confirmHandler={() => {
            cancelEcosystemsChanges(ecosystemToCancel)
          }}
          confirmBtnText='yesCancel'
          rejectBtnText='continueEditing'
          text={<FormattedMessage id='returnDiscardEcosystemChangesText' values={{ ecosystemName: <b>{ecosystemToCancel?.name}</b> }} />}
          item={ecosystemToCancel}
          approve={true}
        />
      </Modal>
    </>
  )
}

export default EcoSystemAccordionHeader